import api from "./axios";

export type WorkOrderKind = "video" | "pc_repair" | "other";
export type WorkOrderStatus = "new" | "in_progress" | "done" | "cancelled";

export interface WorkLine {
  name: string;
  qty: number;
  unit?: string;
  done?: boolean;
}

export interface WorkOrderDto {
  id: number;
  number: string;
  kind: WorkOrderKind;
  kindLabel: string;
  status: WorkOrderStatus;
  title: string;
  dealId: number | null;
  clientId: number | null;
  clientName: string | null;
  assigneeId: number | null;
  assigneeName: string | null;
  coAssigneeIds: number[];
  coAssigneeNames: string[];
  createdById: number | null;
  createdByName: string | null;
  address: string | null;
  contactPhone: string | null;
  description: string | null;
  works: WorkLine[];
  materials: WorkLine[];
  scheduledAt: string | null;
  startedAt: string | null;
  completedAt: string | null;
  resultNote: string | null;
  createdAt: string;
}

export interface WorkOrderInput {
  kind?: WorkOrderKind;
  title?: string;
  dealId?: number | null;
  clientId?: number | null;
  assigneeId?: number | null;
  coAssigneeIds?: number[];
  address?: string | null;
  contactPhone?: string | null;
  description?: string | null;
  works?: WorkLine[];
  materials?: WorkLine[];
  scheduledAt?: string | null;
}

export const KIND_LABELS: Record<WorkOrderKind, string> = {
  video: "Видеонаблюдение",
  pc_repair: "Ремонт компьютеров",
  other: "Прочее",
};

export const STATUS_LABELS: Record<WorkOrderStatus, string> = {
  new: "Новый",
  in_progress: "В работе",
  done: "Выполнен",
  cancelled: "Отменён",
};

export const STATUS_COLORS: Record<WorkOrderStatus, string> = {
  new: "#3b82f6",
  in_progress: "#f59e0b",
  done: "#10b981",
  cancelled: "#6b7280",
};

export const WorkOrdersAPI = {
  list: (params: { scope?: "mine" | "all"; status?: string; assigneeId?: number; dealId?: number } = {}) =>
    api.get<WorkOrderDto[]>("/work-orders", { params }).then((r) => r.data),

  get: (id: number) => api.get<WorkOrderDto>(`/work-orders/${id}`).then((r) => r.data),

  prefill: (dealId: number) =>
    api
      .get<{ dealId: number; clientId: number | null; clientName: string; title: string; address: string; contactPhone: string; description: string; works: WorkLine[]; materials: WorkLine[] }>(
        `/work-orders/prefill/${dealId}`,
      )
      .then((r) => r.data),

  create: (data: WorkOrderInput) => api.post<WorkOrderDto>("/work-orders", data).then((r) => r.data),

  update: (id: number, data: WorkOrderInput) => api.patch<WorkOrderDto>(`/work-orders/${id}`, data).then((r) => r.data),

  progress: (id: number, data: { done?: number[]; resultNote?: string }) =>
    api.patch<WorkOrderDto>(`/work-orders/${id}/progress`, data).then((r) => r.data),

  syncFromDeal: (id: number) =>
    api.post<{ order: WorkOrderDto; added: string[]; changed: string[]; notInDeal: string[] }>(`/work-orders/${id}/sync-deal`).then((r) => r.data),

  setStatus: (id: number, status: WorkOrderStatus, note?: string) =>
    api.post<WorkOrderDto>(`/work-orders/${id}/status`, { status, note }).then((r) => r.data),

  openPdf: async (id: number) => {
    const win = window.open("", "_blank");
    try {
      const res = await api.get(`/work-orders/${id}/pdf`, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      if (win) win.location.href = url;
      else window.location.href = url;
      setTimeout(() => URL.revokeObjectURL(url), 60_000);
    } catch {
      win?.close();
      alert("Не удалось открыть заказ-наряд");
    }
  },
};
